//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PushMsg',
  data() {
    return {
      showDialog: false,
      dialogData: {
        msg: {},
        data: {},
        callBack() {
        }
      }
    }
  },
  methods: {
    show(data) {
      this.dialogData = Object.assign(this.dialogData, data)
      this.showDialog = true
    },
    openUrl() {
      this.dialogData.callBack(this.dialogData)
      this.showDialog = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pushMsg/pushMsg.vue